import React, { useState } from 'react'

import {
  Edit as EditIcon,
  Home as HomeIcon,
  Print as PrintIcon,
} from '@material-ui/icons'
import { DetailTableProps } from './types'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { ProductLabel } from 'src/components/PrintLabel/ProductLabel'
import { ProductDialog } from 'src/modules/supply_chain/components/ProductDialog'
import { BarcodeField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

export const ProductDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print, renderPrintComponent } = useAsyncPrint()

  return (
    <>
      {renderPrintComponent()}
      {updateOpen && (
        <ProductDialog
          open={updateOpen}
          product={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          { Icon: EditIcon, actions: [{ title: 'Edit Product', onClick: () => setUpdateOpen(true) }] },
          {
            Icon: PrintIcon,
            actions: [{ title: 'Print Product Label', onClick: () => print((props) => <ProductLabel {...props} obj={obj.data} />) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'primaryBarcode', label: 'Primary Barcode', renderer: BarcodeField },
        ]}
      />
    </>
  )
}
